import ProjectReducer from './Project.reducer'

export default ProjectReducer
